var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRelax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "301px",
    height: "307px",
    viewBox: "0 0 301 307",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "528848ED-7515-4F8D-BD93-EA63E4FB93A9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HomeKeep---Walkthrough",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ongoing-Maintenance-1-3",
    transform: "translate(-45.000000, -138.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "relax-illustration",
    transform: "translate(45.000000, 138.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.683594,199.783766 C145.265625,199.783766 302,345.783766 300.234053,178.63191 C298,131.283766 229.421865,70 141.332447,70 C53.2430295,70 -1.98951966e-13,113.413155 -1.98951966e-13,172.783766 C-1.98951966e-13,232.154377 66.1015625,199.783766 105.683594,199.783766 Z",
    id: "Oval-Copy-3",
    fill: "#E5FBF8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "avid-humans3-04",
    transform: "translate(22.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D6D8",
    fillRule: "nonzero",
    points: "128 230.128993 120.039474 230.128993 113 302.128993 116.947368 302.128993 122.144737 279.945894"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#D6D6D8",
    fillRule: "nonzero",
    points: "214 230.128993 221 230.128993 219.653846 278.341194 219.519231 301.128993 214.201923 301.128993"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#44A2DA",
    fillRule: "nonzero",
    points: "94.8829268 59.1289926 103 104.178389 72.8780488 116.128993 64 69.2651068"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#AA4E4E",
    fillRule: "nonzero",
    points: "94.9463415 59.1289926 103 105.378993 72.6243902 116.128993 64 68.9414926"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F4F4F5",
    fillRule: "nonzero",
    points: "95.0625 60.1289926 103 106.381764 73.0625 116.128993 65 69.6899682"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#E7E7E7",
    fillRule: "nonzero",
    points: "95.0731707 60.1289926 103 106.338347 72.5609756 116.128993 64 69.3583913"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.415709,71.2173847 C230.957283,74.4997801 227.623596,84.4100892 221.773919,87.8818536 L163.088451,118.622749 C161.578857,119.69584 154.408285,118.748995 152.584192,118.622749 C146.734515,118.244011 102.201491,101.453296 102.201491,101.453296 L100,91.8586018 L158.30807,101.074558 L205.042585,71.7223686 C208.627871,69.2605721 217.245137,67.6193744 224.415709,71.2173847 Z",
    id: "Path",
    fill: "#282C3B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F58A68",
    fillRule: "nonzero",
    points: "86.0859729 273.908809 89 258.128993 75 258.128993 75 278.128993"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(52.000000, 273.128993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.8256697,3.55271368e-14 C34.8256697,3.55271368e-14 42.8776119,11.9703704 41.4358209,12.9777778 C39.9940299,13.9851852 2.00597015,32.4962963 2.00597015,32.4962963 C2.00597015,32.4962963 -2.57014925,25.5074074 3.44776119,22.5481481 C24.1343284,12.2851852 21.4741578,5 21.4741578,5 C30.3751657,1.66666667 34.8256697,3.55271368e-14 34.8256697,3.55271368e-14 Z",
    id: "Path",
    fill: "#D6D6D8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26,
    y1: 14.3710074,
    x2: 34.5,
    y2: 10.3710074,
    id: "Path-23-Copy",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.5,
    y1: 9.37100737,
    x2: 34.5,
    y2: 6.37100737,
    id: "Path-23-Copy-2",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3104478,11.2777778 C41.6238806,12.1592593 41.7492537,12.7888889 41.4985075,12.9777778 C40.0567164,13.9851852 2.06865672,32.4962963 2.06865672,32.4962963 C2.06865672,32.4962963 1.69253731,31.9296296 1.31641791,31.0481481 C7.71044776,27.9 36.1701493,13.9851852 41.3104478,11.2777778 Z",
    id: "Path",
    fill: "#353A4D",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M195.648529,7.42252052 C189.596977,12.1029736 184.869202,15.5816887 187.264608,36.0112338 C189.660014,56.440779 195.333344,51.3175803 187.01246,84.7764948 C178.691577,118.235409 224.393401,107.483017 224.393401,107.483017 L228.932064,82.4995176 C228.932064,82.4995176 247.401905,37.7189667 236.622578,15.7081874 C225.906289,-6.3658412 203.086895,1.66682824 195.648529,7.42252052 Z",
    id: "Path",
    fill: "#FFDC96",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.934587,18.9267215 C235.060318,20.3137572 234.997453,21.700793 234.808856,23.0878288 C233.551544,32.5448908 225.441885,40.2366345 215.069064,41.0562466 C203.250335,42.0019528 192.94038,33.6166911 192.060262,22.3312638 C191.180143,11.0458365 200.04419,1.14744488 211.862919,0.201738681 C223.744514,-0.743967521 234.054469,7.64129413 234.934587,18.9267215 Z",
    id: "Path",
    fill: "#FFDC96",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.112117,69.4860017 C206.260969,69.1111948 192.159795,79.0939598 191.149658,76.6577148 C190.707723,75.5332941 204.493229,62.6145417 204.68263,60.6155715 L211.122254,46.7477158 C212.763727,47.3099261 216.046673,38.3770281 218.887683,40.4384661 C218.887683,40.4384661 220.59229,54.243854 227.473849,65.3006579 C234.418541,76.4199296 215.731005,70.0482121 210.112117,69.4860017 Z",
    id: "Path",
    fill: "#F58A68",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 238.128993)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F58A68",
    fillRule: "nonzero",
    points: "33.4316456 16.4333333 35.3544304 0.062962963 48.5037975 4.15555556 42.5493671 23.862963"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8367089,17.7555556 C45.8367089,17.7555556 43.3556962,34.1888889 41.6189873,33.8740741 C39.8822785,33.5592593 0.0620253165,20.9037037 0.0620253165,20.9037037 C0.0620253165,20.9037037 1.48860759,12.6555556 7.81518987,14.6703704 C29.5860759,21.4703704 33.4316456,14.6703704 33.4316456,14.6703704 L45.8367089,17.7555556 Z",
    id: "Path",
    fill: "#D6D6D8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27,
    y1: 24.3710074,
    x2: 37.5,
    y2: 27.3710074,
    id: "Path-23",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.5,
    y1: 22.3710074,
    x2: 39.5,
    y2: 24.3710074,
    id: "Path-23-Copy-3",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6113924,32.5518519 C42.2392405,33.4333333 41.9291139,33.937037 41.556962,33.937037 C39.8202532,33.6851852 0,20.9666667 0,20.9666667 C0,20.9666667 0.124050633,20.2740741 0.434177215,19.3925926 C7.25696203,21.5333333 37.0911392,31.0407407 42.6113924,32.5518519 Z",
    id: "Path",
    fill: "#353A4D",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#E7E7E7",
    fillRule: "nonzero",
    points: "105.926882 301.128993 114.346237 301.128993 119.273118 279.114661 130 222.128993 101 229.676763 105.926882 278.296986"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#E7E7E7",
    fillRule: "nonzero",
    points: "215.010753 301.128993 206.591398 301.128993 201.664516 279.114661 191 222.128993 220 229.991254 215.010753 278.296986"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E7E7E7",
    fillRule: "nonzero",
    x: 101,
    y: 211.128993,
    width: 120,
    height: 19
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.895411,37.4933616 L219.477527,219.128993 L208,216.75058 L244.417884,35.1149488 C244.97625,32.4235869 247.581959,30.6710722 250.249709,31.2343805 L252.110929,31.6099194 C254.716638,32.1732277 256.453777,34.8019997 255.895411,37.4933616 Z",
    id: "Path",
    fill: "#E7E7E7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,206.977435 C241.553586,90.3778552 253.330379,32.0780655 253.330379,32.0780655 C253.330379,32.0780655 255.744319,33.1797675 256,33.7470479 C256.703123,35.7010139 254.690232,43.7897575 254.690232,43.7897575 L220.42897,210.128993 L218,206.977435 Z",
    id: "Path",
    fill: "#D6D6D8",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.956311,46.0438684 L217.601734,184.108001 C217.34571,185.496849 216.001588,186.380661 214.59346,186.065014 L210.049047,185.181201 C208.640919,184.928684 207.744838,183.602965 208.064867,182.214117 L236.419444,44.1499846 C236.675467,42.7611365 238.019589,41.877324 239.427717,42.1929713 L243.972131,43.0767838 C245.316253,43.3293016 246.212334,44.7181498 245.956311,46.0438684 Z",
    id: "Path",
    fill: "#1B1C1F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221,211.128993 L101,211.128993 L101,200.128993 L216.66719,200.128993 C219.053375,200.128993 221,202.055546 221,204.417128 L221,211.128993 L221,211.128993 Z",
    id: "Path",
    fill: "#1B1C1F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.294845,161.379519 L182.87732,153.544745 L213,159.373817 C213,159.373817 205.139175,195.100388 200.108247,199.111793 C197.529897,201.180173 186.776289,206.382463 168.350515,206.883889 C150.805155,207.322636 122.631959,200.24 117.286598,196.7927 C117.286598,196.7927 99.2381443,175.419435 81.1896907,178.239954 C67.1030928,180.496369 52.5134021,249.128993 52.5134021,249.128993 L30,244.992232 C30,244.992232 34.5907216,199.111793 50.4381443,167.898052 C59.9340206,149.157271 73.014433,150.473513 80.4979381,150.160122 C100.370103,149.345306 131.436082,164.82682 159.294845,161.379519 Z",
    id: "Path",
    fill: "#40BEAD",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.540063,188.355213 C100.831918,182.411202 96.668175,177.530857 85.025641,173.839314 C73.3831071,170.14777 68.5633484,181.722949 68,188.355213 L70.4411765,267.128993 L93.8514329,267.128993 C93.8514329,267.128993 95.4162896,239.411134 98.3582202,217.449579 C99.1719457,211.255295 100.173454,206.812929 103.803922,206.062107 C124.02187,201.995152 151,205.686696 151,205.686696 C151,205.686696 127.997831,194.174086 114.540063,188.355213 Z",
    id: "Path",
    fill: "#00AA94",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#00AA94",
    fillRule: "nonzero",
    points: "160 161.767648 186.054591 171.788656 210 175.128993 171.290323 160.128993"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.266357,70.5910645 C195.685303,71.9262695 180.494033,84.6728392 178.04463,91.2285465 C175.783642,97.1538973 175.846447,107.932993 175.783642,109.319777 C174.527538,130.941004 156,160.189544 156,160.189544 L210.57773,175.128993 L228.854047,81.6471281 C228.854047,81.6471281 237.018725,52.8398374 209.761262,63.4928618 C209.13321,63.80804 201.974121,67.0935059 198.266357,70.5910645 Z",
    id: "Path",
    fill: "#353A4D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.063844,55.637396 L204,62.1289926 C204,62.1289926 208.12681,54.8180683 219.819438,57.0869758 C231.512066,59.3558834 219.75691,47.1289926 219.75691,47.1289926 L207.063844,55.637396 Z",
    id: "Path",
    fill: "#CC674C",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(72.000000, 167.128993)",
    stroke: "#00AA94",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 5.66666667,
    y1: 7.06666667,
    x2: 3.66666667,
    y2: 0.0666666667,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7.06666667,
    y1: 7.4,
    x2: 7.46666667,
    y2: 3.4,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.73333333,
    y1: 7.93333333,
    x2: 0.6,
    y2: 4,
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(96.000000, 196.128993)",
    stroke: "#379A89",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 6.68181818,
    y1: 9.51176471,
    x2: 1.46363636,
    y2: 0.323529412,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.40909091,
    y1: 10.4823529,
    x2: 0.190909091,
    y2: 7.89411765,
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M224.90985,32.8932421 C225.798532,44.3346638 220.022098,54.1957787 211.770051,55.9025101 C211.262232,56.0289346 210.754414,56.0921469 210.246596,56.0921469 C201.169343,56.7874819 193.04425,47.5584898 192.092091,35.4217331 C191.139932,23.2849764 197.678093,12.8549511 206.755345,12.1596161 C215.832597,11.5274933 223.95769,20.7564854 224.90985,32.8932421 Z",
    id: "Path",
    fill: "#F58A68",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#AA4E4E",
    fillRule: "nonzero",
    points: "64 68.7013197 72.6765579 116.185596 107 117.128993 98.0682493 67.1289926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.490449,35.1289926 L193,43.7329529 C193,44.586781 193.712823,45.2435718 194.555251,45.1122137 L196.823325,44.7838182 C197.795357,44.6524601 198.313774,43.5359156 197.795357,42.6820875 L194.490449,35.1289926 Z",
    id: "Path",
    fill: "#F58A68",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.685563,95.4980492 C228.027952,88.4605932 226.766673,73.1289926 226.766673,73.1289926 L205.324931,77.4645682 L162,139.105143 L175.180365,143.440718 C177.576795,144.446069 181.360632,144.823076 186.279619,141.178679 C195.802275,134.266892 221.343173,102.472671 224.685563,95.4980492 Z",
    id: "Path",
    fill: "#282C3B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.445946,118.435194 C169.305019,125.061226 155,131.561047 155,131.561047 L181.100386,132.128993 L220,76.2810124 L217.427606,66.3104126 C215.043436,65.3007316 206.008687,68.6452999 201.491313,72.8733391 C192.582046,81.2663124 178.40251,110.547061 173.445946,118.435194 Z",
    id: "Path",
    fill: "#282C3B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,107.943648 L104.769504,119.128993 L90.8439716,115.702268 C90.6028369,115.637613 90.4219858,115.443648 90.3617021,115.185027 L90,112.728131 C90,112.59882 90,112.534165 90.0602837,112.404855 L90.6631206,110.72382 C90.6631206,110.659165 90.7234043,110.59451 90.7234043,110.59451 L90.9042553,108.978131 C90.9042553,108.913475 90.9042553,108.84882 90.964539,108.784165 L91.4468085,107.685027 C91.4468085,107.620372 91.5070922,107.555717 91.5070922,107.491062 L91.6879433,105.228131 C91.6879433,104.904855 91.9893617,104.646234 92.2907801,104.646234 L100.007092,104.128993 C100.12766,104.128993 100.187943,104.128993 100.308511,104.193648 L107,107.943648 Z",
    id: "Path",
    fill: "#F58A68",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.06824,81.2350183 C223.57072,78.8980655 224.196753,75.7400213 223.94634,72.8346206 C223.57072,68.7291631 221.317,65.1289926 216.99737,65.1289926 C209.046746,65.1289926 202.097775,70.434507 199.969262,74.3504818 L198.216369,77.2558825 L173.801067,117.678849 C172.423794,120.015802 169.669247,121.152697 167.039907,120.521089 L105.93905,106.120407 L105,119.131549 C105,119.131549 157.023373,140.037802 173.30024,141.111537 C189.514505,142.311594 222.06824,81.2350183 222.06824,81.2350183 Z",
    id: "Path",
    fill: "#353A4D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(172.000000, 120.128993)",
    opacity: 0.6,
    stroke: "#181B23",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 5.55111512e-17,
    y1: 0.12,
    x2: 1,
    y2: 6,
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(172.000000, 120.128993)",
    opacity: 0.6,
    stroke: "#181B23",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.4,
    y1: 0.12,
    x2: 3.4,
    y2: 2.7,
    id: "Path"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 158.5,
    y1: 101.628993,
    x2: 158.3,
    y2: 108.128993,
    id: "Path",
    stroke: "#181B23",
    strokeWidth: 1.5,
    opacity: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,16.8004307 C196,16.8004307 206.753544,17.0526396 209.364231,30.1675069 C210.607415,38.0490377 216.823337,36.5357838 220.304253,42.3365905 C223.785169,48.1373971 201.842656,98.6368202 247.840475,104.878993 C240.567846,93.214327 251.613923,74.8644556 251.303127,67.0459771 C250.930172,57.7142446 240.304332,53.4554776 240.739446,38.4490429 C241.671835,5.09440454 221.796074,1.35263028 212.907306,2.23536173 C204.018539,3.11809318 196,16.8004307 196,16.8004307 Z",
    id: "Path",
    fill: "#FFDC96",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.693331,171.128993 C157.693331,171.128993 148.532807,179.902655 164,184.128993",
    id: "Path",
    stroke: "#00AA94",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#379A89",
    fillRule: "nonzero",
    points: "94.3796526 268.128993 70.4342432 268.128993 70 260.128993 95 260.128993"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#379A89",
    fillRule: "nonzero",
    points: "52.9271357 249.128993 30 244.753302 31.1306533 237.128993 55 241.305788"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelax);
export default __webpack_public_path__ + "static/media/relax.155074a48850b3e510be9c4f82b571ae.svg";
export { ForwardRef as ReactComponent };